import {
  GET_SEASON_YEAR_ERROR,
  GET_SEASON_YEAR_REQUEST,
  GET_SEASON_YEAR_SUCCESS,
  ADD_SEASON_YEAR_ERROR,
  ADD_SEASON_YEAR_REQUEST,
  ADD_SEASON_YEAR_SUCCESS,
  DELETE_SEASON_YEAR_REQUEST,
  DELETE_SEASON_YEAR_SUCCESS,
  DELETE_SEASON_YEAR_ERROR,
  UPDATE_SEASON_YEAR_ERROR,
  UPDATE_SEASON_YEAR_REQUEST,
  UPDATE_SEASON_YEAR_SUCCESS,

  // GET_STYLE_REQUEST,
  // GET_STYLE_SUCCESS,
  // GET_STYLE_ERROR
  ////////////////////////////////////

} from "./types";
import { BASEURL } from "../../constant/config.js";
import { COMPANY_ID } from "../../utils/CompanyId.js";

const axios = require("axios");

export const getSeasonYear = (token, menu_id) => (dispatch) => {
  dispatch({ type: GET_SEASON_YEAR_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/seasonYear`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { menu_id, company_id: COMPANY_ID }
  })
    .then((response) => {
      return dispatch({ type: GET_SEASON_YEAR_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      return dispatch({
        type: GET_SEASON_YEAR_ERROR,
        payload: error.response,
      });
    });
};

export const addSeasonYear = (token, data, menu_id) => (dispatch) => {
  console.log(data,"dataaaaa")
  dispatch({ type: ADD_SEASON_YEAR_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}create/seasonYear`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { season_year: data.seasonYears, is_active: data.check, menu_id:22 },
  })
    .then((response) => {

      return dispatch({ type: ADD_SEASON_YEAR_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      return dispatch({
        type: ADD_SEASON_YEAR_ERROR,
        payload: error.response,
      });
    });
};

export const updateSeasonYear = (token, data, id) => (dispatch) => {
  dispatch({ type: UPDATE_SEASON_YEAR_REQUEST });
  return axios({
    method: "PUT",
    url: `${BASEURL}update/seasonYear/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { season_year: data.seasonYears, is_active: data.check },
  })
    .then((response) => {

      return dispatch({ type: UPDATE_SEASON_YEAR_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      return dispatch({
        type: UPDATE_SEASON_YEAR_ERROR,
        payload: error.response,
      });
    });
};

export const deleteSeasonYear = (token, id) => (dispatch) => {
  dispatch({ type: DELETE_SEASON_YEAR_REQUEST });
  return axios({
    method: "DELETE",
    url: `${BASEURL}delete/seasonYear/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {

      return dispatch({ type: DELETE_SEASON_YEAR_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      return dispatch({
        type: DELETE_SEASON_YEAR_ERROR,
        payload: error.response,
      });
    });
};


// export const getStyleChange = (token, gender_id, gender_category_id) => (dispatch) => {
//   dispatch({ type: GET_STYLE_REQUEST });
//   let data = {
//     gender_id: gender_id === "All" ? null : gender_id,
//     gender_category_id: gender_category_id === null ? null : gender_category_id
//   }
//   return axios({
//     method: "POST",
//     url: `${BASEURL}getAll/getstyle`,
//     headers: {
//       Accept: "application/json",
//       Authorization: "Bearer " + token,
//     },
//     data: data
//   })
//     .then((response) => {
//       return dispatch({ type: GET_STYLE_SUCCESS, payload: response.data });
//     })
//     .catch((error) => {
//       return dispatch({
//         type: GET_STYLE_ERROR,
//         payload: error.response,
//       });
//     });
// };